import styles from './Rooms.module.css';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';
import SearchBar from '../../components/SearchBar/SearchBar';
import Dropdown from '../../components/Dropdown/Dropdown';
import { IoMdTrash } from 'react-icons/io';
import Dynamic from '../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../components/PaginationTable/PaginationTable';
import LogoWithName from '../../components/LogoWithName/LogoWithName';
import Action from '../../components/Action/Action';
import FixedLogoWithName from '../../components/FixedLogoWithName/FixedLogoWithName';
import IconAndName from '../../components/IconAndName/IconAndName';
import { IoAddCircleOutline } from 'react-icons/io5';
import CopyRight from '../../components/CopyRight/CopyRight';
import { useNavigate } from 'react-router';

const data = [
  {
    _id: 'gnswkgnseknsg1',
    label: 'xtejkew4',
    color: 'blue',
    StudentsIn: '8',
    StudentsOut: '10',
    StudentPending: '08',
    StaffIn: '07',
    StaffOut: '03',
    StaffPending: '02',
    Roomoccupied: '00',
    Minage: '01',
    Maxage: '0100',
    Action: ['Transfer', 'Delete'],
  },
  {
    _id: 'gnswkgnseknsg1',
    label: 'xtejkew4',
    color: 'blue',
    StudentsIn: '8',
    StudentsOut: '10',
    StudentPending: '08',
    StaffIn: '07',
    StaffOut: '03',
    StaffPending: '02',
    Roomoccupied: '00',
    Minage: '01',
    Maxage: '0100',
    Action: ['Transfer', 'Delete'],
  },
  {
    _id: 'gnswkgnseknsg1',
    label: 'xtejkew4',
    color: 'blue',
    StudentsIn: '8',
    StudentsOut: '10',
    StudentPending: '08',
    StaffIn: '07',
    StaffOut: '03',
    StaffPending: '02',
    Roomoccupied: '00',
    Minage: '01',
    Maxage: '0100',
    Action: ['Transfer', 'Delete'],
  },
  {
    _id: 'gnswkgnseknsg1',
    label: 'xtejkew4',
    color: 'var(--Error_Color)',
    StudentsIn: '8',
    StudentsOut: '10',
    StudentPending: '08',
    StaffIn: '07',
    StaffOut: '03',
    StaffPending: '02',
    Roomoccupied: '00',
    Minage: '01',
    Maxage: '0100',
    Action: ['Transfer', 'Delete'],
  },
  {
    _id: 'gnswkgnseknsg1',
    label: 'xtejkew4',
    color: 'var(--Error_Color)',
    StudentsIn: '8',
    StudentsOut: '10',
    StudentPending: '08',
    StaffIn: '07',
    StaffOut: '03',
    StaffPending: '02',
    Roomoccupied: '00',
    Minage: '01',
    Maxage: '0100',
    Action: ['Transfer', 'Delete'],
  },
  {
    _id: 'gnswkgnseknsg1',
    label: 'xtejkew4',
    color: 'var(--Error_Color)',
    StudentsIn: '8',
    StudentsOut: '10',
    StudentPending: '08',
    StaffIn: '07',
    StaffOut: '03',
    StaffPending: '02',
    Roomoccupied: '00',
    Minage: '01',
    Maxage: '0100',
    Action: ['Transfer', 'Delete'],
  },
  {
    _id: 'gnswkgnseknsg1',
    label: 'xtejkew4',
    color: 'blue',
    StudentsIn: '8',
    StudentsOut: '10',
    StudentPending: '08',
    StaffIn: '07',
    StaffOut: '03',
    StaffPending: '02',
    Roomoccupied: '00',
    Minage: '01',
    Maxage: '0100',
    Action: ['Transfer', 'Delete'],
  },
];

function Rooms() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const navigate = useNavigate();

  const handleRoom = () => {
    dispatch(openModal('addroom'));
  };
  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => {
                const checked = e.target.checked;
                setSelectedIds((prev) =>
                  checked
                    ? [...prev, item._id]
                    : prev.filter((id) => id !== item._id)
                );
              }}
            />
          </div>
        ),
        Roomname: (
          <span
            onClick={() => navigate('/management/students')}
            style={{ cursor: 'pointer' }}
          >
            <FixedLogoWithName
              label={item.label}
              color={item.color || 'green'}
            />
          </span>
        ),
        StudentsIn: item.StudentsIn,
        StudentsOut: item.StudentsOut,
        StudentPending: item.StudentPending,
        StaffIn: item.StaffIn,
        StaffOut: item.StaffOut,
        StaffPending: item.StaffPending,
        Roomoccupied: item.Roomoccupied,
        Minage: item.Minage,
        Maxage: item.Maxage,

        Action: (
          <Action
            key={item._id}
            options={item.actionOptions || ['Edit', 'Delete']}
            onSelect={(opt) => {
              console.log(`Selected "${opt}" for ${item.Roomname}`);
              if (opt === 'Edit') {
                dispatch(openModal('addroom'));
              } else if (opt === 'Transfer') {
                dispatch(openModal('TransferStudent'));
              } else if (opt === 'Delete') {
                dispatch(openModal('delete'));
              }
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Room Name', accessor: 'Roomname' },
    { title: 'Students In', accessor: 'StudentsIn' },
    { title: 'StudentsOut', accessor: 'StudentsOut' },
    { title: 'StudentPending', accessor: 'StudentPending' },
    { title: 'Staff In', accessor: 'StaffIn' },
    { title: 'Staff Out', accessor: 'StaffOut' },
    { title: 'StaffPending', accessor: 'StaffPending' },
    { title: 'Room occupied', accessor: 'Roomoccupied' },
    { title: ' Minage', accessor: 'Minage' },
    { title: 'Maxage', accessor: 'Maxage' },
    { title: 'Actions', accessor: 'Action' },
  ];

  return (
    <>
      <div className={styles.pageWrapper}>
        <div className={styles.headerContainer}>
          {/* Status boxes */}

          {/* Search and Filters */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Room "
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.Addroom}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Add Room"
                  bgColor="Primary_Color"
                  onClick={handleRoom}
                />

                <IoMdTrash
                  size={26}
                  style={{
                    opacity: 0.4,
                    color: 'var(--Black_Color)',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    dispatch(openModal('delete'));
                  }}
                />
              </div>
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
        <div className={styles.copyRightContainer}>{<CopyRight />}</div>
      </div>
    </>
  );
}

export default Rooms;
